﻿import Handlebars from "@cirrus/legacy/vendor-bower/handlebars/handlebars"

;(function (Handlebars, Marionette) {
  Marionette.TemplateCache.prototype.loadTemplate = function (templateId) {
    return templateId
  }

  Marionette.TemplateCache.prototype.compileTemplate = function (rawTemplate) {
    return Handlebars.compile(rawTemplate)
  }
})(Handlebars, Marionette)
